'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.guardAgainstReservedFieldName = guardAgainstReservedFieldName;
var reservedFieldNames = exports.reservedFieldNames = ['__options', '__inertia', '__page', '__validateRequestType', 'data', 'delete', 'errorFor', 'errorsFor', 'hasErrors', 'initial', 'isDirty', 'onFail', 'onSuccess', 'patch', 'post', 'processing', 'put', 'recentlySuccessful', 'reset', 'submit', 'successful', 'withData', 'withOptions'];

function guardAgainstReservedFieldName(fieldName) {
    if (reservedFieldNames.indexOf(fieldName) !== -1) {
        throw new Error('Field name ' + fieldName + ' isn\'t allowed to be used in a Form or Errors instance.');
    }
}